<template>
    <div>
        <v-header>
          <template #collapseBtn>
            <div class="collapse-btn" @click="collapseChage">
              <img v-if="!getCollapse" src="@/assets/img/icon-pack-down.svg" class="collapse-icon-cls" width="100%" />
              <img v-else src="@/assets/img/icon-pack-up.svg" class="collapse-icon-cls" width="100%" />
          </div>
          </template>
        </v-header>
        <v-sidebar></v-sidebar>
        <div class="content-box" :class="{'content-collapse':getCollapse}">
            <v-tags></v-tags>
            <div class="content">
                <transition name="move" mode="out-in">
                    <router-view></router-view>
                </transition>
                <el-backtop target=".content"></el-backtop>
            </div>

            <v-bottom :isCollapse="getCollapse? 't': 'f'"></v-bottom>
        </div>
    </div>
</template>

<script>
  import VHeader from './Header.vue';
  import VSidebar from './Sidebar.vue';
  import VTags from './Tags.vue';
  import VBottom from './Bottom.vue';
  import {mapGetters} from 'vuex'

  export default {
    data() {
      return {
        tagsList: []
      }
    },
    computed: {
      ...mapGetters('common', {
        getUser: 'getUser',
        getCollapse: 'getCollapse'
      })
    },
    components: {
      VHeader, VSidebar, VTags, VBottom
    },
    methods: {
      // 侧边栏折叠
      collapseChage() {
          this.$store.commit('common/setCollapse', !this.getCollapse)
      },
    },
  }
</script>

<style>
    .content-box {
        position: absolute;
        left: 255px;
        right: 0;
        top: 70px;
        bottom: 0;
        padding-bottom: 46PX;
        -webkit-transition: left .3s ease-in-out;
        transition: left .3s ease-in-out;
        background: #eff1f5;
    }

    .content-collapse {
        left: 84px;
    }

    .collapse-btn {
        float: left;
        padding: 0 25px;
        font-size: 22px;
        cursor: pointer;
        line-height: 70px;
        background-color: #00338d;
        width: 84px;
        text-align: center;
    }
    .collapse-icon-cls {
        width: 22px;
    }
</style>
